module.exports = __webpack_public_path__ + "assets/img/274f7f255f38ac1484f3f51dac1d9e8e.png";